<template>
  <div ref="modal" class="modal gang-sheet-info-modal" role="dialog">
    <div class="gang-sheet-info-modal__modal-box modal-dialog">
      <div class="gang-sheet-info-modal__modal-body">
        <button class="gang-sheet-info-modal__modal-button-close" type="button" @click="closeModal">
          <UseSvg icon="modal-close-big" />
        </button>
        <div class="gang-sheet-info-modal__image-box">
          <div class="gang-sheet-info-modal__image-bg"></div>
          <img
            v-if="!isMobile"
            :src="gangSheetDesktopImage"
            alt="Sample image 1"
            class="gang-sheet-info-modal__image"
          />
          <img
            v-if="isMobile && isNewDtfCustomer"
            :src="gangSheetMobileSmallImage"
            alt="Sample image 1"
            class="gang-sheet-info-modal__image"
          />
          <img
            v-if="isMobile && !isNewDtfCustomer"
            :src="gangSheetMobileBigImage"
            alt="Sample image 1"
            class="gang-sheet-info-modal__image"
          />
        </div>
        <div
          class="gang-sheet-info-modal__info"
          :class="{
            'gang-sheet-info-modal__info--wide-margin': isMobile
          }"
        >
          <UseSvg icon="jiffy-transfers-inline" class="gang-sheet-info-modal__logo" />
          <div class="gang-sheet-info-modal__title gang-sheet-info-modal__title--wide-margin">
            <p class="gang-sheet-info-modal__title-text">JiffyTransfers supports</p>
            <p class="gang-sheet-info-modal__title-text">Gang Sheet printing!</p>
          </div>
          <button
            class="gang-sheet-info-modal__button gang-sheet-info-modal__button--white"
            type="button"
            @click="redirectToGangSheetUrl"
          >
            Upload a Gang Sheet
          </button>
          <span class="gang-sheet-info-modal__small-text">or</span>
          <button
            class="gang-sheet-info-modal__button gang-sheet-info-modal__button--pink"
            type="button"
            @click="redirectToDtfUrl"
          >
            Upload single images
          </button>

          <div
            class="gang-sheet-info-modal__info-text gang-sheet-info-modal__info-text--wide-margin"
          >
            What is
            <a
              :href="jiffyTransferLink()"
              class="gang-sheet-info-modal__info-link"
              @click="closeModal"
            >
              Jiffy Transfers?
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "jiffy-api";
import { isMobile, redirectTo } from "common/utils/browser";
import { writePersistentCookie } from "common/utils/cookie";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import UseSvg from "common/vue/components/UseSvg.vue";

export default {
  name: "GangSheetInfoModal",
  components: { UseSvg },
  props: {
    currentStore: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      closed: false,
      isMobile: isMobile()
    };
  },
  computed: {
    gangSheetDesktopImage() {
      return remoteImageStaticUrl("gen/gangsheet-modal-image.png");
    },
    gangSheetMobileSmallImage() {
      return remoteImageStaticUrl("gen/gang-sheet-info-image-mobile-small2.png");
    },
    gangSheetMobileBigImage() {
      return remoteImageStaticUrl("gen/gang-sheet-info-image-mobile-big.png");
    }
  },
  mounted() {
    this.showModal();
  },
  methods: {
    showModal() {
      const $$modal = $(this.$refs.modal);
      $$modal.modal("show").on("hidden.bs.modal", () => {
        $$modal.off("hidden.bs.modal");
        if (!this.closed) {
          this.closeModal();
        }
      });
    },
    closeModal() {
      $(this.$refs.modal).modal("hide");
      this.closed = true;

      writePersistentCookie("gang-sheet-info-modal-shown", true);
    },
    jiffyTransferLink() {
      const baseLink = "/jiffytransfers";
      return this.currentStore === "ca" ? `/ca${baseLink}` : baseLink;
    },
    redirectToGangSheetUrl() {
      const baseLink = "/jiffytransfers-DTFGANG001.html";
      const redirectPath = this.currentStore === "ca" ? `/ca${baseLink}` : baseLink;
      redirectTo(redirectPath);
      this.closeModal();
    },
    redirectToDtfUrl() {
      const baseLink = "/jiffytransfers-DTF001.html";
      const redirectPath = this.currentStore === "ca" ? `/ca${baseLink}` : baseLink;
      redirectTo(redirectPath);
      this.closeModal();
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin.scss";
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/button/mixin.scss";

.gang-sheet-info-modal {
  &__modal-box {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    width: 360px;
    height: 640px;

    @include with-desktop {
      width: 860px;
      height: 634px;
    }
  }

  &__modal-body {
    font-family: sans-serif;
    color: $dark-blue2;
    display: flex;
    height: 100%;
    flex-direction: column;

    @include with-desktop {
      flex-direction: row;
    }
  }

  &__modal-button-close {
    @include clear-button;
    @include svg-wrapper;

    position: absolute;
    top: 0;
    right: 0;
    width: 48px;
    height: 48px;
    padding: 16px;
    z-index: 1;
  }

  &__logo {
    width: 171px;
    height: 18px;
  }

  &__image-box {
    background-color: $dtf-pink;
    overflow: hidden;

    @include with-desktop {
      flex: 46%;
    }
  }

  &__image {
    object-fit: cover;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    display: block;
  }

  &__info {
    flex: 54%;
    background-color: $white;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;

    &--wide-margin {
      padding-top: 40px;
    }

    @include with-desktop {
      padding-top: 80px;
    }
  }

  &__small-text {
    font-size: 14px;
    line-height: 21px;
    margin: 4px 0;

    @include with-desktop {
      margin: 16px 0;
    }
  }

  &__title {
    margin: 10px 0;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    color: $dark-blue2;

    &--wide-margin {
      margin-bottom: 20px;
    }

    @include with-desktop {
      font-size: 30px;
      font-weight: bold;
      margin: 12px 0 24px;

      &--wide-margin {
        margin-bottom: 97px;
      }
    }
  }

  &__title-text {
    margin: 0;
  }

  &__button {
    font-size: 17px;
    line-height: 24px;
    font-weight: 600;
    border-radius: 5px;
    padding: 10px 12px;
    border: none;

    &--white {
      color: $white;
      background-color: $bright-pink;
    }

    &--pink {
      color: $borneo-pink-gradient-finish;
      background-color: $light-pink-2;
    }
  }

  &__promo-box {
    border-top: 2px dashed $app-gray-modern-200;
    width: 80%;
    margin-top: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @include with-desktop {
      margin-top: 50px;
    }
  }

  &__promo-title {
    margin-top: 20px;
    font-size: 20px;
    font-weight: 600;

    @include with-desktop {
      margin-top: 34px;
      font-size: 24px;
      font-weight: bold;
    }
  }

  &__promo-text {
    font-size: 16px;
    font-weight: normal;
  }

  &__promo-code {
    color: $bright-pink;
    background-color: $lighter-pink;
    border: 2px dashed $bright-pink;
    padding: 8px 12px;
    border-radius: 5px;
    margin: 16px 0;

    @include with-desktop {
      margin: 12px 0;
    }
  }

  &__promo-code-text {
    font-family:
      Arial Black,
      sans-serif;
    font-size: 30px;
    font-weight: 900;
    line-height: 30px;
  }

  &__info-text {
    color: $dark-blue2;
    font-size: 12px;
    font-weight: bold;

    &--wide-margin {
      margin-top: 45px;
    }
  }

  &__info-link {
    color: $dark-blue2;
    text-decoration: underline;
  }
}
</style>
